import { createTemplateFactory } from "@ember/template-factory";
export default createTemplateFactory(
/*
  <section class="field category-logo">
  <label>{{i18n "category.logo"}}</label>
  <UppyImageUploader
    @imageUrl={{this.logoImageUrl}}
    @onUploadDone={{action "logoUploadDone"}}
    @onUploadDeleted={{action "logoUploadDeleted"}}
    @type="category_logo"
    @id="category-logo-uploader"
    class="no-repeat contain-image"
  />
</section>

<section class="field category-logo">
  <label>{{i18n "category.logo_dark"}}</label>
  <UppyImageUploader
    @imageUrl={{this.logoImageDarkUrl}}
    @onUploadDone={{action "logoDarkUploadDone"}}
    @onUploadDeleted={{action "logoDarkUploadDeleted"}}
    @type="category_logo_dark"
    @id="category-dark-logo-uploader"
    class="no-repeat contain-image"
  />
</section>

<section class="field category-background-image">
  <label>{{i18n "category.background_image"}}</label>
  <UppyImageUploader
    @imageUrl={{this.backgroundImageUrl}}
    @onUploadDone={{action "backgroundUploadDone"}}
    @onUploadDeleted={{action "backgroundUploadDeleted"}}
    @type="category_background"
    @id="category-background-uploader"
  />
</section>

<section class="field category-background-image">
  <label>{{i18n "category.background_image_dark"}}</label>
  <UppyImageUploader
    @imageUrl={{this.backgroundDarkImageUrl}}
    @onUploadDone={{action "backgroundDarkUploadDone"}}
    @onUploadDeleted={{action "backgroundDarkUploadDeleted"}}
    @type="category_background_dark"
    @id="category-dark-background-uploader"
  />
</section>
*/
{
  "id": "fflhgRgt",
  "block": "[[[10,\"section\"],[14,0,\"field category-logo\"],[12],[1,\"\\n  \"],[10,\"label\"],[12],[1,[28,[35,0],[\"category.logo\"],null]],[13],[1,\"\\n  \"],[8,[39,1],[[24,0,\"no-repeat contain-image\"]],[[\"@imageUrl\",\"@onUploadDone\",\"@onUploadDeleted\",\"@type\",\"@id\"],[[30,0,[\"logoImageUrl\"]],[28,[37,2],[[30,0],\"logoUploadDone\"],null],[28,[37,2],[[30,0],\"logoUploadDeleted\"],null],\"category_logo\",\"category-logo-uploader\"]],null],[1,\"\\n\"],[13],[1,\"\\n\\n\"],[10,\"section\"],[14,0,\"field category-logo\"],[12],[1,\"\\n  \"],[10,\"label\"],[12],[1,[28,[35,0],[\"category.logo_dark\"],null]],[13],[1,\"\\n  \"],[8,[39,1],[[24,0,\"no-repeat contain-image\"]],[[\"@imageUrl\",\"@onUploadDone\",\"@onUploadDeleted\",\"@type\",\"@id\"],[[30,0,[\"logoImageDarkUrl\"]],[28,[37,2],[[30,0],\"logoDarkUploadDone\"],null],[28,[37,2],[[30,0],\"logoDarkUploadDeleted\"],null],\"category_logo_dark\",\"category-dark-logo-uploader\"]],null],[1,\"\\n\"],[13],[1,\"\\n\\n\"],[10,\"section\"],[14,0,\"field category-background-image\"],[12],[1,\"\\n  \"],[10,\"label\"],[12],[1,[28,[35,0],[\"category.background_image\"],null]],[13],[1,\"\\n  \"],[8,[39,1],null,[[\"@imageUrl\",\"@onUploadDone\",\"@onUploadDeleted\",\"@type\",\"@id\"],[[30,0,[\"backgroundImageUrl\"]],[28,[37,2],[[30,0],\"backgroundUploadDone\"],null],[28,[37,2],[[30,0],\"backgroundUploadDeleted\"],null],\"category_background\",\"category-background-uploader\"]],null],[1,\"\\n\"],[13],[1,\"\\n\\n\"],[10,\"section\"],[14,0,\"field category-background-image\"],[12],[1,\"\\n  \"],[10,\"label\"],[12],[1,[28,[35,0],[\"category.background_image_dark\"],null]],[13],[1,\"\\n  \"],[8,[39,1],null,[[\"@imageUrl\",\"@onUploadDone\",\"@onUploadDeleted\",\"@type\",\"@id\"],[[30,0,[\"backgroundDarkImageUrl\"]],[28,[37,2],[[30,0],\"backgroundDarkUploadDone\"],null],[28,[37,2],[[30,0],\"backgroundDarkUploadDeleted\"],null],\"category_background_dark\",\"category-dark-background-uploader\"]],null],[1,\"\\n\"],[13]],[],false,[\"i18n\",\"uppy-image-uploader\",\"action\"]]",
  "moduleName": "discourse/components/edit-category-images.hbs",
  "isStrictMode": false
});